import {
    ACCOUNTS_GET_ACCOUNT_OPEN_MODAL,
    ACCOUNTS_GET_ACCOUNT_REQUEST,
    ACCOUNTS_GET_ACCOUNT_RESULT,
} from 'Redux/actionTypes';

export const accountsGetDetailsAccountOpenModal = (open, account) => ({
    type: ACCOUNTS_GET_ACCOUNT_OPEN_MODAL,
    payload: { open, account }
})

export const accountsGetDetailsAccountRequest = (data) => ({
    type: ACCOUNTS_GET_ACCOUNT_REQUEST,
    payload: data
})

export const accountsGetDetailsAccountResult = (result) => ({
    type: ACCOUNTS_GET_ACCOUNT_RESULT,
    payload: result
})
